import React, { useState, createContext } from 'react'

const SearchContext = createContext<[string, (val: string) => any]>([
  '',
  (_val: string) => '',
])

const SearchProvider: React.JSX.CFC = ({ children }) => {
  const [searchText, setSearchText] = useState('')

  return (
    <SearchContext.Provider value={[searchText, setSearchText]}>
      {children}
    </SearchContext.Provider>
  )
}

export { SearchContext, SearchProvider }
